module.exports = __webpack_public_path__ + "static/media/blog-01.9acff4f0.jpg";